import { USER_OPTIONS } from "../../config/constants.js";
import { ResolvePermalinkUrl } from "./functions.js";

export class UserPrivateView {
  showMenuInHeader(_user) {
    if (!_user) {
      _user = {};
    }
    let name = (_user.name || '').replace(',', '').split(' ')[0];
    document.getElementById('header-menu').innerHTML = `
      <div class="user-session" id="user-session" onclick="app.userPrivateController.menu()">
        <span>${name}</span>
        <div
          class="image" style="background-image: url(${_user.imageURL}), url(/assets/img/user.jpg)"
          onclick="${ResolvePermalinkUrl(_user.permalink, false)}"
        ></div>
      </div>
      <div class="user-menu" id="user-menu">
        <div id="btn-header-account" onclick="${ResolvePermalinkUrl(_user.permalink, true)}">Mi perfil</div>
        <hr>
        <h3 style=" padding: 0px 20px; margin-bottom: 5px;">Mis publicaciones</h3>
        <div id="btn-header-productos" onclick="app.userPrivateController.router('productos');app.userPrivateController.menu();">Productos</div>
        <div id="btn-header-maquinaria" onclick="app.userPrivateController.router('maquinaria');app.userPrivateController.menu();">Máquinas</div>
        <div id="btn-header-inmuebles" onclick="app.userPrivateController.router('inmuebles');app.userPrivateController.menu();">Inmuebles</div>
        <div id="btn-header-servicios" onclick="app.userPrivateController.router('servicios');app.userPrivateController.menu();">Servicios</div>
        <hr>
        <div id="btn-header-account" onclick="app.userPrivateController.router('account');app.userPrivateController.menu();">Configuración de mi cuenta</div>
        <hr>
        <div onclick="app.userPrivateController.auth.logout();app.userPrivateController.menu();" style="color: var(--rojo)">Cerrar sesión</div>
      </div>
    `;
  }

  showMainContent(_user) {
    if (!_user) {
      _user = {};
    }

    let location = _user.city || '';
    if (location && _user.state) {
      location += ', ' + _user.state;
    }

    let occupation = USER_OPTIONS.Cargos.find(i => i.value == _user.occupation)?.text || '';
    if (occupation.startsWith('--')) {
      occupation = '(Debe definir su cargo)';
    }

    content.innerHTML = `
      <div class="user-header">
        <div class="profile">
          <div class="image" style="background-image: url(${_user.imageURL}), url(/assets/img/user.jpg)" onclick="${ResolvePermalinkUrl(_user.permalink, true)}"></div>
          <div class="text">
            <div class="title">${_user.name || ''}</div>
            <div class="description">
              ${occupation || ''}
              <br>
              ${location}
            </div>
          </div>
        </div>
        <nav>
          <a id="btn-productos" href="javascript:app.userPrivateController.router('productos');app.userPrivateController.menu(false);">Productos</a>
          <a id="btn-maquinaria" href="javascript:app.userPrivateController.router('maquinaria');app.userPrivateController.menu(false);">Máquinas</a>
          <a id="btn-inmuebles" href="javascript:app.userPrivateController.router('inmuebles');app.userPrivateController.menu(false);">Inmuebles</a>
          <a id="btn-servicios" href="javascript:app.userPrivateController.router('servicios');app.userPrivateController.menu(false);">Servicios</a>
          <a id="btn-account" href="javascript:app.userPrivateController.router('account');app.userPrivateController.menu(false);">Confirguración de mi cuenta</a>
          <div class="user-plan-indicator" id="user-plan-indicator" onclick="app.userPrivateController.router('account');app.userPrivateController.menu(false);">---</div>
        </nav>
      </div>
      <div id="user-content">
        <div class="loader gray"></div>
      </div>
    `;
  }

  renderPublishModal() {
    return `
      <div class="publish-container">
        <button class="producto" onclick="app.userPrivateController.publishAction('producto')">Producto</button>
        <button class="maquinaria" onclick="app.userPrivateController.publishAction('maquinaria')">Maquinaria</button>
        <button class="inmueble" onclick="app.userPrivateController.publishAction('inmueble')">Inmueble</button>
        <button class="servicio" onclick="app.userPrivateController.publishAction('servicio')">Servicio</button>
      </div>
    `;
  }


  //#region PRICE OPTIONS
  renderPriceOptions(_entity, _data, _isNew) {
    let htmlRadio1 = '';
    let htmlRadio2 = '';
    let htmlContenedor1 = '';
    let htmlContenedor2 = '';

    if (_isNew) {
      htmlRadio1 = 'checked';
    } else {
      if ((_data.precio && _data.precio.toString().trim().length == 0) ||
        (_data.moneda == '0')
      ) {
        htmlRadio2 = 'checked';
        htmlContenedor1 = 'style="opacity: 0.5; pointer-events: none;"';
        htmlContenedor2 = 'style="opacity: 0.5; pointer-events: none;"';
      } else {
        htmlRadio1 = 'checked';
      }
    }

    return `
      <div class="group">
        <b>Precio</b>
        <div class="group vertical" style="margin-bottom: 5px">
          <div>
            <input type="radio" id="${_entity}-precio-radio-1" name="precio-radio" ${htmlRadio1} onchange="app.userPrivateController.view.changePriceOptions('${_entity}', true)"/>
            Fijar precio
          </div>
          <div>
            <input type="radio" id="${_entity}-precio-radio-2" name="precio-radio" ${htmlRadio2} onchange="app.userPrivateController.view.changePriceOptions('${_entity}', false)"/>
            A definir
          </div>
        </div>
        <div class="group vertical">
          <div class="group" id="${_entity}-precio-contenedor" ${htmlContenedor1}>
            Importe
            <br>
            <input type="number" id="${_entity}-precio" min="0" value="${_data.precio || ''}"> 
          </div>
          <div class="group" id="${_entity}-moneda-contenedor" ${htmlContenedor2}>
            Moneda
            <br>
            <select id="${_entity}-moneda" value="${_data.moneda || '0'}"></select>
          </div>
          <span id="${_entity}-precio-error"></span>
          <span id="${_entity}-moneda-error"></span>
        </div>
      </div>
    `;
  }

  changePriceOptions(_idElem, _status) {
    let domPrice = document.getElementById(_idElem + '-precio-contenedor');
    let domMoney = document.getElementById(_idElem + '-moneda-contenedor');

    if (domPrice && domMoney) {
      if (_status === true) {
        domPrice.removeAttribute('style');
        domMoney.removeAttribute('style');
      } else {
        domPrice.setAttribute('style', 'opacity: 0.5; pointer-events: none');
        domPrice.querySelector('input').value = '';
        domMoney.setAttribute('style', 'opacity: 0.5; pointer-events: none');
        domMoney.querySelector('select').selectedIndex = 0;
      }
    }
  }
  //#endregion

  renderPublishButton(_status) {
    if (_status === true) {
      _status = '1';
    }
    if (_status === false) {
      _status = '0';
    }
    let checked = (_status === '1' ? "checked" : '');
    let text = (_status === '1' ? "Publicado" : 'Oculto');
    let color = (_status === '1' ? "var(--gris3)" : 'var(--gris1');
    return `
    <div class='publish'>
      <span>
        <b style="${color}" id="publish-text">${text}</b>
      </span>
      <label class="switch" id="publish-switch" onclick="app.userPrivateController.changePublicationVisibility();">
        <input id='visible' type="checkbox" ${checked}>
        <span class="slide round"></span>
      </label>
      <a href="/user/account" style=" font-size: 18px; grid-column: span 2;">¿Necesitas más capacidad?</a>
    </div>
    `;
  }

}
